import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { productCompareFlyOutStyles } from "@dana/Overrides/Components/ProductCompareFlyOut";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

productCompareFlyOutStyles.carousel = mergeToNew(productCompareFlyOutStyles.carousel, {
    carouselContainer: {
        css: css`
            padding: 5px 0;
        `,
    },
});

productCompareFlyOutStyles.carouselDrawer = mergeToNew(productCompareFlyOutStyles.carouselDrawer, {
    cssOverrides: {
        drawerTitle: css`
            background: ${themeBackgrounds.lightGray};
        `,
    },
});

productCompareFlyOutStyles.headerTitleText = mergeToNew(productCompareFlyOutStyles.headerTitleText, {
    css: css`
        margin-bottom: 0;
    `,
});

productCompareFlyOutStyles.carouselDrawerContainer = mergeToNew(productCompareFlyOutStyles.carouselDrawerContainer, {
    css: css`
        padding: 24px;
    `,
});

productCompareFlyOutStyles.removeProductFromCompareButton = mergeToNew(
    productCompareFlyOutStyles.removeProductFromCompareButton,
    {
        css: css`
            &:active,
            &:hover {
                border: none;
            }
        `,
    },
);

productCompareFlyOutStyles.removeProductFromCompareButton = mergeToNew(
    productCompareFlyOutStyles.removeProductFromCompareButton,
    {
        css: css`
            padding: 0;
            background: transparent;
            border: none;
        `,
    },
);
